import { cn } from '@/shared/utils/cn';
import React from 'react';
import { Checkbox } from '@/modules/Checkbox';
import { ListHeader } from '../molecules/ListHeader';
import { ListSeparator } from '../molecules/ListSeparator';

export interface ListFiltersCheckboxItem {
  id: string;
  label: string;
  checked?: boolean;
}

export interface ListFiltersCheckboxProps {
  title?: string;
  items: ListFiltersCheckboxItem[];
  onItemToggle?: (itemId: string) => void;
  onClear?: () => void;
  onApply?: (selectedIds: string[]) => void;
  onBack?: () => void;
  clearLabel?: string;
  applyLabel?: string;
  className?: string;
}

export const ListFiltersCheckbox: React.FC<ListFiltersCheckboxProps> = ({
  title = 'Headline',
  items,
  onItemToggle,
  onClear,
  onApply,
  onBack,
  clearLabel = '🧹 Limpiar',
  applyLabel = 'Ok',
  className,
}) => {
  const selectedIds = items.filter((item) => item.checked).map((item) => item.id);

  return (
    <div
      className={cn(
        'ui-rounded-surface-card ui-border ui-border-default ui-bg-fill ui-p-8 ui-shadow-03',
        'ui-flex ui-min-w-[208px] ui-flex-col ui-gap-8',
        className,
      )}
    >
      {/* Header */}
      <ListHeader title={title} onBackClick={onBack} />

      <ListSeparator />

      {/* Filter Items with Checkboxes */}
      <div className="ui-flex ui-flex-col ui-gap-8">
        {items.map((item) => (
          <div
            key={item.id}
            onClick={() => onItemToggle?.(item.id)}
            className={cn(
              'ui-flex ui-cursor-pointer ui-items-center ui-gap-8 ui-rounded-control-sm ui-px-8 ui-py-6 ui-transition-all',
              {
                // Hover: gris claro
                'hover:ui-bg-fill-hover': true,
              },
            )}
          >
            <Checkbox
              checked={item.checked || false}
              onChange={() => onItemToggle?.(item.id)}
              size="md"
            />
            <span className="ui-text-body-sm-regular ui-font-body-sm-medium ui-text-primary">
              {item.label}
            </span>
          </div>
        ))}
      </div>

      <ListSeparator />

      {/* Action Buttons */}
      <div className="ui-flex ui-gap-8">
        <button
          onClick={onClear}
          className="ui-h-20 ui-flex-1 ui-rounded-control-sm ui-border ui-border-default ui-bg-surface-secondary ui-px-8 ui-py-4 ui-text-body-xs-regular ui-font-body-xs-bold ui-text-primary ui-transition-colors hover:ui-bg-surface-secondary-hover"
        >
          {clearLabel}
        </button>
        <button
          onClick={() => onApply?.(selectedIds)}
          className="ui-h-20 ui-flex-1 ui-rounded-control-sm ui-bg-fill-brand ui-px-8 ui-py-4 ui-text-body-xs-regular ui-font-body-xs-bold ui-text-on-color ui-transition-colors hover:ui-bg-fill-brand-hover"
        >
          {applyLabel}
        </button>
      </div>
    </div>
  );
};
